import axios from "axios";
import auth from "@/services/auth";
import CryptoJS from "crypto-js";


export default{
   async getAllStrankeProtustranke()
    {
        try {
            return axios.get("https://app-psod.cratis.cloud/api/osoba/fizicka");
          } catch (err) {
            console.log(err);
          }
    },
    getAllIndustries()
    {
        try {
            return axios.get("https://app-psod.cratis.cloud/api/osoba/industries");
          } catch (err) {
            console.log(err);
          }
    },


    async getSingleStrankaProtustranka(oib)
    {
      let accessToken = await auth.acquireToken(process.env.GRAPH_SCOPES);

        try {
            return axios.get("https://app-psod.cratis.cloud/api/osoba/fizicka/" + oib, {
              params: {
                accessToken,
              },
              credentials: true,
            });
          } catch (err) {
            console.log(err);
          }
    },
    async getPhisPersCommunication(oib)
    {
      let accessToken = await auth.acquireToken(process.env.GRAPH_SCOPES);

        try {
            return axios.get("https://app-psod.cratis.cloud/api/osoba/fizicka/" + oib+'/communication', {
              params: {
                accessToken,
              },
              credentials: true,
            });
          } catch (err) {
            console.log(err);
          }
    },
    getEditPhisEntity(oib)
    {
        try {
            return axios.get("https://app-psod.cratis.cloud/api/osoba/fizicka/" + oib+"/edit");
          } catch (err) {
            console.log(err);
          }
    },
    updateFizicka(osoba,oib)
    {
        try {
            return axios.put("https://app-psod.cratis.cloud/api/osoba/fizicka/" + oib, {
              params: {
                osoba,
              },
              credentials: true,
            });
          } catch (err) {
            console.log(err);
          }
    },
    updatePravna(osoba,oib)
    {
        try {
            return axios.put("https://app-psod.cratis.cloud/api/osoba/pravna/" + oib, {
              params: {
                osoba,
              },
              credentials: true,
            });
          } catch (err) {
            console.log(err);
          }
    },
    insertFizicka(osoba)
    {
        try {
            return axios.post("https://app-psod.cratis.cloud/api/osoba/fizicka", {
              params: {
                osoba,
              },
              credentials: true,
            });
          } catch (err) {
            console.log(err);
          }
    },
    insertPravna(osoba)
    {
        try {
            return axios.post("https://app-psod.cratis.cloud/api/osoba/pravna", {
              params: {
                osoba,
              },
              credentials: true,
            });
          } catch (err) {
            console.log(err);
          }
    },
    updatePravna(osoba, uid)
    {
        try {
            return axios.put("https://app-psod.cratis.cloud/api/osoba/pravna/" + uid, {
              params: {
                osoba,
              },
              credentials: true,
            });
          } catch (err) {
            console.log(err);
          }
    },
    quickinsertFizicka(osoba)
    {
        try {
            return axios.post("https://app-psod.cratis.cloud/api/osoba/fizicka/quick", {
              params: {
                osoba,
              },
              credentials: true,
            });
          } catch (err) {
            console.log(err);
          }
    },
    quickinsertPravna(osoba)
    {
        try {
            return axios.post("https://app-psod.cratis.cloud/api/osoba/pravna/quick", {
              params: {
                osoba,
              },
              credentials: true,
            });
          } catch (err) {
            console.log(err);
          }
    },
   async getAllOsobe(personType)
    {

      // let accessToken = await auth.acquireToken(process.env.GRAPH_SCOPES);
      // // console.log(accessToken)
      // console.log(process.env.VUE_APP_SECRET_KEY.toString() === '8y/B?E(G+KbPeShVmYq3t6w9z$C&F)J@McQfTjWnZr4u7x!A%D*G-KaPdRgUkXp2')
      // var bytes  = CryptoJS.AES.encrypt(accessToken, '8y/B?E(G+KbPeShVmYq3t6w9z$C&F)J@McQfTjWnZr4u7x!A%D*G-KaPdRgUkXp2');
      // console.log(bytes)

        try {
            return axios.get("https://app-psod.cratis.cloud/api/osoba/all",{
              params: {
                personType
              },
            });
          } catch (err) {
            console.log(err);
          }
    },
    getAllFizLeg()
    {
        try {
            return axios.get("https://app-psod.cratis.cloud/api/osoba/fiz-leg");
          } catch (err) {
            console.log(err);
          }
    },
    async getOdvjetnik(oib)
    {
      let accessToken = await auth.acquireToken(process.env.GRAPH_SCOPES);
        try {
            return axios.get("https://app-psod.cratis.cloud/api/osoba/law/"+oib, {
              params: {
                accessToken,
              },
              credentials: true,
            });
          } catch (err) {
            console.log(err);
          }
    },
    async editOdvjetnik(uid, person)
    {
      let accessToken = await auth.acquireToken(process.env.GRAPH_SCOPES);
        try {
            return axios.put("https://app-psod.cratis.cloud/api/osoba/law/"+uid, {
              params: {
                accessToken,
                person
              },
              credentials: true,
            });
          } catch (err) {
            console.log(err);
          }
    },
    async getOdvjetnikComunication(oib)
    {
      let accessToken = await auth.acquireToken(process.env.GRAPH_SCOPES);
        try {
            return axios.get("https://app-psod.cratis.cloud/api/osoba/law/"+oib+"/comunication", {
              params: {
                accessToken,
              },
              credentials: true,
            });
          } catch (err) {
            console.log(err);
          }
    },
    async getLegBodyComunication(oib)
    {
      let accessToken = await auth.acquireToken(process.env.GRAPH_SCOPES);
        try {
            return axios.get("https://app-psod.cratis.cloud/api/osoba/leg-body/"+oib+"/comunication", {
              params: {
                accessToken,
              },
              credentials: true,
            });
          } catch (err) {
            console.log(err);
          }
    },
    async getSluzbena(oib)
    {
      let accessToken = await auth.acquireToken(process.env.GRAPH_SCOPES);
        try {
            return axios.get("https://app-psod.cratis.cloud/api/osoba/leg/"+oib, {
              params: {
                accessToken,
              },
              credentials: true,
            });
          } catch (err) {
            console.log(err);
          }
    },
   async getPravna(oib)
    {
      let accessToken = await auth.acquireToken(process.env.GRAPH_SCOPES);
        try {
            return axios.get("https://app-psod.cratis.cloud/api/osoba/pravna/"+oib, {
              params: {
                accessToken,
              },
              credentials: true,
            });
          } catch (err) {
            console.log(err);
          }
    },
    async getPravnaComunication(oib)
    {
      let accessToken = await auth.acquireToken(process.env.GRAPH_SCOPES);
        try {
            return axios.get("https://app-psod.cratis.cloud/api/osoba/pravna/"+oib+"/comunication", {
              params: {
                accessToken,
              },
              credentials: true,
            });
          } catch (err) {
            console.log(err);
          }
    },
    searchAll(srch_txt)
    {
        try {
            return axios.get("https://app-psod.cratis.cloud/api/osoba/search", {
              params: {
                srch_txt,
              },
              credentials: true,
            });
          } catch (err) {
            console.log(err);
          }
    },
    getAllStatusi() {
      try {
        return axios.get("https://app-psod.cratis.cloud/api/osoba/statusi");
      } catch (err) {
        console.log(err);
      }
    },
    getAllProjectStatuses() {
      try {
        return axios.get("https://app-psod.cratis.cloud/api/osoba/statusi-project");
      } catch (err) {
        console.log(err);
      }
    },



    //legal body-s START

   async get_all_legal_body()
    {
      let accessToken = await auth.acquireToken(process.env.GRAPH_SCOPES);
      try {
        return axios.get("https://app-psod.cratis.cloud/api/legal-body", {
          params: {
            accessToken,
          },
          credentials: true,
        });
      } catch (err) {
        console.log(err);
      }
    },

    get_all_legal_body_short()
    {
      try {
        return axios.get("https://app-psod.cratis.cloud/api/legal-body/short");
      } catch (err) {
        console.log(err);
      }
    },
    
    create_legal_body(leg_body)
    {
      try {
        return axios.post("https://app-psod.cratis.cloud/api/legal-body", {
          params: {
            leg_body,
          },
          credentials: true,
        });

      } catch (err) {
        console.log(err);
      }
    },
    update_legal_body(leg_body, uid)
    {
      try {
        return axios.put("https://app-psod.cratis.cloud/api/legal-body/"+uid, {
          params: {
            leg_body,
          },
          credentials: true,
        });

      } catch (err) {
        console.log(err);
      }
    },

    async get_single_legal_body(uid)
    {
      let accessToken = await auth.acquireToken(process.env.GRAPH_SCOPES);
      try {
        return axios.get("https://app-psod.cratis.cloud/api/legal-body/"+ uid, {
          params: {
            accessToken,
          },
          credentials: true,
        });
      } catch (err) {
        console.log(err);
      }
    },

    //legal body-s END
    deleteFizicka(uid)
    {
        try {
            return axios.delete("https://app-psod.cratis.cloud/api/osoba/fizicka/" + uid, {
              credentials: true,
            });
          } catch (err) {
            console.log(err);
          }
    },
    deletePravna(uid)
    {
        try {
            return axios.delete("https://app-psod.cratis.cloud/api/osoba/pravna/" + uid, {
              credentials: true,
            });
          } catch (err) {
            console.log(err);
          }
    },
    deleteSluzbena(uid)
    {
        try {
            return axios.delete("https://app-psod.cratis.cloud/api/legal-body/" + uid, {
              credentials: true,
            });
          } catch (err) {
            console.log(err);
          }
    },

}